(function () {
  var items = document.querySelectorAll(".nav-item[data-panel]");
  var panel = document.querySelector(".nav-mega-panel");
  if (!items.length || !panel) {
    return;
  }

  var contents = panel.querySelectorAll(".nav-mega-content");
  var closeTimer = null;

  function activate(key) {
    contents.forEach(function (content) {
      var isActive = content.getAttribute("data-panel") === key;
      content.classList.toggle("is-active", isActive);
      if (isActive) {
        loadLazyVideos(content);
      }
    });
    items.forEach(function (item) {
      item.classList.toggle("is-open", item.getAttribute("data-panel") === key);
    });
  }

  // The "Início" panel video only starts downloading once this panel is
  // actually opened — it used to have `autoplay`, which fetched the whole
  // file on every page load even though the mega-menu is hidden by default.
  function loadLazyVideos(content) {
    var videos = content.querySelectorAll("[data-lazy-video]");
    videos.forEach(function (video) {
      if (!video.src) {
        video.src = video.getAttribute("data-lazy-video");
      }
      video.play().catch(function () {});
    });
  }

  function pauseVideos() {
    panel.querySelectorAll("[data-lazy-video]").forEach(function (video) {
      video.pause();
    });
  }

  function open(key) {
    clearTimeout(closeTimer);
    activate(key);
    panel.classList.add("is-open");
    document.body.classList.add("nav-open");
  }

  function close() {
    panel.classList.remove("is-open");
    document.body.classList.remove("nav-open");
    items.forEach(function (item) {
      item.classList.remove("is-open");
    });
    pauseVideos();
  }

  function scheduleClose() {
    clearTimeout(closeTimer);
    closeTimer = setTimeout(close, 150);
  }

  items.forEach(function (item) {
    var key = item.getAttribute("data-panel");

    item.addEventListener("mouseenter", function () {
      open(key);
    });
    item.addEventListener("mouseleave", function () {
      scheduleClose();
    });
    item.addEventListener("focusin", function () {
      open(key);
    });
    item.addEventListener("focusout", function (event) {
      if (!item.contains(event.relatedTarget)) {
        scheduleClose();
      }
    });
  });

  panel.addEventListener("mouseenter", function () {
    clearTimeout(closeTimer);
  });
  panel.addEventListener("mouseleave", function () {
    scheduleClose();
  });

  document.addEventListener("keydown", function (event) {
    if (event.key === "Escape") {
      close();
    }
  });

  var overlay = document.querySelector(".page-overlay");
  if (overlay) {
    overlay.addEventListener("click", close);
  }
})();
